import { Api } from "./Api.class";
const endpoint = "recruiters";
const RecruitersAPI = new Api(endpoint);
export default RecruitersAPI;
